import {
    formatData, getGaClientId, GA_EVENT_CHECKOUT, GA_CHECKOUT_CATEGORY, TRACK_SHIPPING_NAME_STORAGE_KEY,
    TRACK_GATEWAY_PAYMENT_STORAGE_KEY
} from '@common/Tracking';
import { parseJSON } from '@helpers/data';
import { set } from '@helpers/localStorage';
import { getVisitorDataCookieAsObject } from '@helpers/visitor';

export const SELECT_INFO_NAMESPACE = 'ga.gateway.';
export const SHIPPING_INFO_NAMESPACE = 'ga.checkout.service.shipping.';

const assembleCheckoutData = (step, choice, confirmStep = 5) => {
    const eventData = {
        ...formatData(getVisitorDataCookieAsObject()),
        client_id: getGaClientId(),
        ...App.Config.GaTrackingData,
        ecommerce: {
            checkout: {
                actionField: {
                    step
                }
            }
        }
    };
    const eventInfo = {
        category: GA_CHECKOUT_CATEGORY,
        action: `step ${step}`,
        label: null,
        value: null,
        non_interaction: 1
    };

    const formatOption = (start, value) => {
        const option = `${start}${value}.${eventData.browsing_country}`;
        return option.toLowerCase();
    };

    switch (step) {
        case 1:

        // eslint-disable-next-line no-fallthrough
        case confirmStep: {
            const { gateways } = App.Config.Checkout;

            if (typeof gateways[App.Config.paymentId] !== 'undefined') {
                const payOption = gateways[App.Config.paymentId].replace('gateway.', '');
                eventData.ecommerce.checkout.actionField.option = formatOption(`${choice}-`, payOption);

                eventInfo.label = formatOption(SELECT_INFO_NAMESPACE, payOption);

                // save selected gateway payment for tracking order completed
                set(TRACK_GATEWAY_PAYMENT_STORAGE_KEY, gateways[App.Config.paymentId]);
            }

            return {
                eventName: GA_EVENT_CHECKOUT,
                eventInfo,
                eventData
            };
        }

        case 3: {
            const checkedNode = document.querySelector(".shipby-box input[type='radio']:checked")
            || document.querySelector(".shipping-info input[type='radio']:checked");

            if (checkedNode) {
                const selected = checkedNode.getAttribute('value');
                const shippings = parseJSON(App.Config.shippings);

                if (typeof shippings[selected] !== 'undefined') {
                    // save shipping name for thank-you page tracking
                    const shippingName = shippings[selected].name;
                    set(TRACK_SHIPPING_NAME_STORAGE_KEY, shippingName);

                    const shipOption = shippingName.replace('_', '.');
                    eventData.ecommerce.checkout.actionField.option = formatOption(`${choice}-`, shipOption);
                    eventInfo.label = formatOption(SHIPPING_INFO_NAMESPACE, shipOption);
                }
            }

            return {
                eventName: GA_EVENT_CHECKOUT,
                eventInfo,
                eventData
            };
        }

        default: {
            return {
                eventName: GA_EVENT_CHECKOUT,
                eventInfo,
                eventData
            };
        }
    }
};

export default assembleCheckoutData;
